export enum LabelType {
    NAME = "NAME",
    POINT = "POINT",
    RECTANGLE = "RECTANGLE",
    POLYGON = "POLYGON",
    CATEGORY = "CATEGORY"
}